import React from 'react'
import Typography from 'material-ui/Typography'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { ModalHeader, ModalContents, ModalFooter } from '../../../common/modal'

import { withStyles } from 'material-ui/styles'
import styles from './styles'


class UploadLT4Copperlimits extends React.Component {

    state = {
      modal : false,
      limitdbfile : null,
      limitdbzipfile : null,
      errors : {

      }
    }

  handleChange = e =>  {
    let errors = {...this.state.errors}
    if(e.target.type=='file' && e.target.files.length){
      let fileExtention = e.target.files[0].name.split('.').pop();
      if(fileExtention === 'json'){
        this.setState({
          [e.target.name] : e.target.files[0],
          errors : {
            ...errors,
            [e.target.name] : false
          }
        })
      }else{
        this.setState({
          errors : {
            ...errors,
            [e.target.name] : true
          }
        })
      }
    }
  }

  handleZipChange = e => {
    let errors = { ...this.state.errors }
    if (e.target.type == 'file' && e.target.files.length) {
      let fileExtention = e.target.files[0].name.split('.').pop();
      if (fileExtention === 'zip') {
        this.setState({
          [e.target.name]: e.target.files[0],
          errors: {
            ...errors,
            [e.target.name]: false
          }
        })
      }
      else {
        this.setState({
          errors: {
            ...errors,
            [e.target.name]: true
          }
        })
      }
    }
  }

  uploadLimitDbFile = e => {
    e.preventDefault()
    let jsonFile = this.state.limitdbfile
    let zipFile = this.state.limitdbzipfile
    if (jsonFile && zipFile) {
        var fd = new FormData();
        fd.append('file', jsonFile)
        fd.append('file', zipFile)
        fd.append('type', 'Comet')

      this.props.uploadLt4LimitDb(fd)
      this.props.onClose()
    }
  }

  render(){
    const { classes, translate, onClose } = this.props
    const { limitdbfile, errors, limitdbzipfile } = this.state
    return (
      <Modal open={true} onClose={onClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("settings_lt4copper_limitsdb_title")}
              </Typography>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={errors.limitdbfile ? true : false}
                  >
                  <InputLabel htmlFor="limitdbfile" shrink={true} disableAnimation={true}>{translate("settings_lt4copper_limitsdb_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="limitdbfile"
                      type="file"
                      name="limitdbfile"
                      onChange={this.handleChange}
                      inputProps={{
                        accept: ".json",
                        name:"limitdbfile"
                      }}
                  />
                  <FormHelperText id="limitdbfile-helper-text">{translate("settings_copper_limitsdb_help")}</FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={errors.limitdbzipfile ? true : false}
                  >
                  <InputLabel htmlFor="limitdbzipfile" shrink={true} disableAnimation={true}>{translate("settings_lt4copper_limitsdb_label")}</InputLabel>
                  <Input
                      className={classes.upload}
                      id="limitdbzipfile"
                      type="file"
                      name="limitdbzipfile"
                      onChange={this.handleZipChange}
                      inputProps={{
                        accept: ".zip",
                        name:"limitdbzipfile"
                      }}
                  />
                  <FormHelperText id="limitdbzipfile-helper-text">
                    {translate("settings_device_software_help")}
                  </FormHelperText>
                </FormControl>
              </form>
            </ModalContents>
            <ModalFooter>
              <Button raised
                onClick={onClose}
              >
                {translate('general_cancel')}
              </Button>
              {limitdbfile && limitdbzipfile ? (<Button raised
                color="accent"
                type="submit"
                onClick={this.uploadLimitDbFile}
              >
                {translate("settings_upload")}
              </Button>) : null}
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }

}

export default withStyles(styles)(UploadLT4Copperlimits)
